import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listSharedUsers = async ({
    userRoleUuid,
    paginationLimit = 50,
    paginationToken = null
}) =>
    api.get('/users/shared', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            'PAGINATION-LIMIT': paginationLimit,
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
        }
    });

export const createSharedUser = async ({ userRoleUuid, email }) =>
    api.post(
        '/users/shared',
        { email },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const deleteSharedUser = async ({ userRoleUuid, userUuid }) =>
    api.delete('/users/shared', {
        headers: makeRoleHeaders(userRoleUuid),
        data: {
            user: userUuid
        }
    });
